export { MatcherType } from './core-video-config.enums';
export function isRemoteConfigEnabled(sdkConfig) {
    var _sdkConfig_remoteConfigurationService;
    return Boolean((_sdkConfig_remoteConfigurationService = sdkConfig.remoteConfigurationService) === null || _sdkConfig_remoteConfigurationService === void 0 ? void 0 : _sdkConfig_remoteConfigurationService.enabled);
} // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type -- Exact function type is unimportant
 // Base Config
 // Config that is stored in the `default` field and used partially
 // inside each playback type or device matcher override
 // Merged Config
 // Config after it has been merged with device matchers and
 // PlaybackType overrides (undefined if there were no overrides for that PlaybackType)
 // Playback Types Config
 // Config that includes the based config on `default` and any
 // Playback specific overrides as partials of the base config
 // Using syntax from @npm/semver `satisfies`
 // Config With Device Matchers
 // Config that extends the Playback Types Config with a device matchers array.
 // The device matchers contain partials of the playback types config and will be
 // used to override specific values based on matching device information
 // Compiled Config
 // Duplicate of the Device Matchers config, except that every optional parameter
 // is extended to allow for the custom "undefined" string. Since JSON does not support
 // actual `undefined` values, this string is used to store fake "undefined" and we
 // replace all references to it with `undefined` once the file is fetched.

//# sourceMappingURL=core-video-config-types.js.map